/*
 * Sticky mobile add-to-cart bar (.add_to_cart_fix).
 * Hidden by default via CSS (opacity 0 + visibility hidden + pointer-events none,
 * so it never steals taps from content underneath). Shown only while the real
 * buy buttons are scrolled above the viewport.
 */
(() => {
  const fixButton = document.querySelector(".add_to_cart_fix");
  const buyButtons = document.querySelector(
    ".product__info-wrapper .product-form__buttons"
  );
  if (!fixButton || !buyButtons) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      const scrolledPast =
        !entry.isIntersecting && entry.boundingClientRect.top < 0;
      fixButton.classList.toggle("is-visible", scrolledPast);
    },
    { threshold: 0 }
  );
  observer.observe(buyButtons);
})();
